import { useFormContext } from "react-hook-form";
import { t } from "@/i18n-js/instance";
import { TippyV2 } from "@circle-react-shared/TippyV2";
import { Form } from "@circle-react-uikit/Form";

export const LessonSettings = () => {
  const { watch } = useFormContext();
  const { featured_media, featured_media_enabled } = watch();
  const isFeaturedMediaAVideo =
    featured_media?.content_type?.includes("video/");
  return (
    <>
      <Form.Item
        id="featured_media_enabled"
        name="featured_media_enabled"
        hideBorder
        hideDescription
        className="!pt-0"
      >
        <Form.Checkbox
          label={t("courses.edit.lesson.enable_featured_media")}
          name="featured_media_enabled"
          className="!mt-2"
        />
      </Form.Item>
      <Form.Item
        id="comments_enabled"
        name="comments_enabled"
        hideBorder
        hideDescription
        className="!pt-0"
      >
        <Form.Checkbox
          label={t("courses.edit.lesson.enable_comments")}
          name="comments_enabled"
          className="!mt-2"
        />
      </Form.Item>
      {featured_media_enabled && (
        <TippyV2
          content={t("courses.edit.lesson.add_featured_media_to_enable")}
          arrow={false}
          disabled={isFeaturedMediaAVideo}
        >
          <Form.Item
            id="enforce_featured_media_completion"
            name="enforce_featured_media_completion"
            hideBorder
            hideDescription
            className="!pt-0"
          >
            <Form.Checkbox
              name="enforce_featured_media_completion"
              label={t("courses.edit.lesson.enforce_featured_media_completion")}
              description={t(
                "courses.edit.lesson.enforce_featured_media_completion_description",
              )}
              className="!mt-2"
              disabled={!isFeaturedMediaAVideo}
              isDescriptionTooltip
            />
          </Form.Item>
        </TippyV2>
      )}
      {featured_media_enabled && (
        <TippyV2
          content={t("courses.edit.lesson.add_featured_media_to_enable")}
          arrow={false}
          disabled={isFeaturedMediaAVideo}
        >
          <Form.Item
            id="autocomplete_on_featured_media_completion"
            name="autocomplete_on_featured_media_completion"
            hideBorder
            hideDescription
            className="!pt-0"
          >
            <Form.Checkbox
              name="autocomplete_on_featured_media_completion"
              label={t(
                "courses.edit.lesson.autocomplete_on_featured_media_completion",
              )}
              description={t(
                "courses.edit.lesson.autocomplete_on_featured_media_completion_description",
              )}
              className="!mt-2"
              disabled={!isFeaturedMediaAVideo}
              isDescriptionTooltip
            />
          </Form.Item>
        </TippyV2>
      )}
    </>
  );
};
